// extracted by mini-css-extract-plugin
export default {"wrapper":"bodyMarkerImage_wrapper__gCxuI"};